/**
 * Sends successful Horizon add-to-cart actions to Klaviyo.
 *
 * Klaviyo's Shopify app embed loads the onsite queue, but this theme does not
 * emit Klaviyo's "Added to Cart" metric on its own. Horizon already exposes a
 * standard cart event with a completion promise, so tracking here avoids false
 * events when Shopify rejects an add.
 */
document.addEventListener('shopify:cart:lines-update', async (event) => {
  const action = event.action || event.detail?.action;
  const lines = event.lines || event.detail?.lines;
  const completion = event.promise || event.detail?.promise;
  if (action !== 'add' || !Array.isArray(lines)) return;

  try {
    const result = completion
      ? await completion
      : await new Promise((resolve) => window.setTimeout(() => resolve({}), 500));
    if (result?.detail?.didError || result?.userErrors?.length) return;

    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return;

    const cart = await response.json();
    const addedVariantIds = new Set(lines.map((line) => String(line.merchandiseId || line.id)));
    const addedItems = cart.items.filter((item) => addedVariantIds.has(String(item.variant_id)));

    for (const item of addedItems) {
      const line = lines.find(
        (candidate) => String(candidate.merchandiseId || candidate.id) === String(item.variant_id)
      );
      const quantity = Number(line?.quantity) || Number(item.quantity) || 1;
      const unitPrice = Number(item.final_price || item.price || 0) / 100;
      const productUrl = new URL(item.url, window.location.origin).href;
      const payload = {
        $value: unitPrice * quantity,
        AddedItemProductName: item.product_title,
        AddedItemProductID: item.product_id,
        AddedItemVariantID: item.variant_id,
        AddedItemVariantName: item.variant_title,
        AddedItemSKU: item.sku,
        AddedItemCategories: item.product_type ? [item.product_type] : [],
        AddedItemImageURL: item.image,
        AddedItemURL: productUrl,
        AddedItemPrice: unitPrice,
        AddedItemQuantity: quantity,
        ItemNames: addedItems.map((addedItem) => addedItem.product_title),
        Items: addedItems,
        URL: productUrl,
        CheckoutURL: `${window.location.origin}/cart`,
      };

      if (typeof window.klaviyo?.track === 'function') {
        window.klaviyo.track('Added to Cart', payload);
      } else if (typeof window.klaviyo?.push === 'function') {
        window.klaviyo.push(['track', 'Added to Cart', payload]);
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['track', 'Added to Cart', payload]);
      }
    }
  } catch (error) {
    console.warn('[Hidden Gems] Klaviyo Added to Cart tracking skipped.', error);
  }
});
